import { Burger } from '../core'

$.fn.Header = function(parent) {
  let self = this
  self.cloned = undefined
  self.parent = parent
  self.burger = undefined
  self.scrolling = $(window).ScrollEvents()
  self.past = false
  self.top = 0;

  if (self.data('header')) {
    return self.data('header')
  }

  self.initialize_burger = function() {
    self.burger = new Burger(self.find('.header__burger').get(0), {
      onToggle: function(burger) {
        var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        if (scrollTop != 0) {
          self.top = scrollTop
        }
        $('body').css('--top',-scrollTop + 'px');
        if (burger.isExpanded) {
          $('.burger').attr('aria-expanded', 'true');
          $('body').addClass('--menu-open --no-scroll')
          $('body').removeClass('--product-menu-open')
          $('body').removeClass('--category-open')
        } else {
          $('.burger').attr('aria-expanded', 'false');
          $('body').removeClass('--menu-open --no-scroll')
        }
        window.scrollTo({ top: self.top});
      },
    })
  }

  self.find('.product-toggle').click(function() {
    var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
    if (scrollTop != 0) {
      self.top = scrollTop
    }
    var fixed_header = $('body').hasClass('--header-visible')
    $('body').toggleClass('--product-menu-open --no-scroll')
    $('body').css('--top',-scrollTop + 'px');
    $(this).toggleClass('--selected')
    if (fixed_header) {
      $('body').addClass('--force-header-visible');
    } else {
      $('body').removeClass('--force-header-visible');
    }
    window.scrollTo({ top: self.top});
    return false;
  })

  $(window).click(function() {
    if ($('body').hasClass('--no-scroll')) {
      window.scrollTo({ top: self.top});
    }
    $('body').removeClass('--product-menu-open --no-scroll --force-header-visible')
  });

  $('.product-menu, .header').click(function(event){
    event.stopPropagation();
  });

  $('.back-to-menu-btn').click(function() {
    $('body').removeClass('--category-open')
    return false;
  })

  $('.close-menu-btn').click(function() {
    $('body').removeClass('--menu-open')
    $('.burger').attr('aria-expanded', 'false');
    return false;
  })

  $('.product-category-btn').click(function() {
    $('body').addClass('--category-open')
    $('body').attr('data-product-category', $(this).attr('data-slug'))
    return false;
  })

  self.scrolled = function(top, direction) {
    if (!self.past && top > 300) {
      $('body').addClass('--header-visible')
      self.past = true
    } else if (self.past && top <= 300) {
      $('body').removeClass('--header-visible')
      self.past = false
    }
  }

  self.initialize_cloned = function() {
    self.cloned = self.clone().Header(self)
    self.after(self.cloned)
  }

  return function() {
    if (self.parent == undefined) {
      setTimeout(function() {
        $('body').removeClass('--menu-dismissed--initial')
      }, 250)
    }
    self.initialize_burger()
    if (self.parent != undefined) {
      self.addClass('header--fixed')
    }
    if (self.parent == undefined) {
      self.initialize_cloned()
      self.scrolling.add(self.scrolled)
      $(window).on('load resize orientationchange', self.scrolled)
      self.scrolled()
      self.data('header', self)
    }
    return self
  }()
}
